const mediaItems = [
  {
    title: '某千万粉网红深夜直播翻车全程',
    views: '328万',
    date: '3小时前',
    duration: '12:48',
    tag: '网红塌房',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20studio%20scene%20with%20dramatic%20red%20and%20coral%20lighting%2C%20spotlight%20effect%20on%20empty%20stage%2C%20modern%20broadcast%20studio%20aesthetic%2C%20mysterious%20atmosphere%2C%20soft%20glow%2C%20cinematic%20lighting%2C%20no%20text%2C%20no%20people%2C%20entertainment%20news%20theme%20with%20vibrant%20warm%20tones&width=800&height=500&seq=media-card-01&orientation=landscape',
  },
  {
    title: '网曝门最新投稿：博主人设崩塌实录',
    views: '256万',
    date: '6小时前',
    duration: '08:35',
    tag: '网曝门',
    img: 'https://readdy.ai/api/search-image?query=Warm%20amber%20and%20deep%20burgundy%20abstract%20composition%2C%20geometric%20layered%20shapes%2C%20modern%20editorial%20news%20visual%2C%20soft%20gradient%20glow%2C%20dramatic%20atmospheric%20lighting%2C%20sophisticated%20mysterious%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20entertainment%20platform%20thumbnail%20style&width=800&height=500&seq=media-card-02&orientation=landscape',
  },
  {
    title: '娱乐圈年度最大爆料时间线全还原',
    views: '412万',
    date: '12小时前',
    duration: '18:22',
    tag: '明星爆料',
    img: 'https://readdy.ai/api/search-image?query=Rich%20dark%20coral%20and%20warm%20gold%20abstract%20backdrop%2C%20soft%20light%20rays%20from%20top%20corner%2C%20modern%20cinematic%20composition%2C%20luxurious%20dark%20aesthetic%2C%20editorial%20photography%20style%2C%20no%20text%2C%20no%20people%2C%20dramatic%20contrast%20with%20elegant%20warm%20highlights&width=800&height=500&seq=media-card-03&orientation=landscape',
  },
];

export default function MediaCards() {
  return (
    <section id="media" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            精选视频
          </h2>
          <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full whitespace-nowrap">
            Videos
          </span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer hover:border-primary-300/50 transition-all duration-300"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 right-3 bg-black/70 text-white text-xs px-2 py-0.5 rounded whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center shadow-lg shadow-primary-500/40">
                    <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm font-semibold text-foreground-800 leading-snug mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="whitespace-nowrap">
                    <i className="ri-eye-line mr-1"></i>
                    {item.views}
                  </span>
                  <span className="whitespace-nowrap">{item.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}